import { useState, useEffect, useRef } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { API } from 'aws-amplify';
import {ButtonWithSound} from '../Button/Button';
import './Valuation.scss';

const Valuation = (props) => {
    const { login } = useSelector((state) => state.loginReducer, shallowEqual);
    const [checkedItems, setCheckedItems] = useState({})

    const updateScore = async () => {
        try {
            await API.post('TIR', '/v3/student/result', {
            body: {
                student_id: login.studentid,
                metric: props.questions ? `${props.name}_level4_scorecard` : `${props.name}_foundational_skills`,
                result: JSON.stringify({
                day: props.day,
                topic: props.topic,
                created: new Date().toISOString(),
                values: [{ value: Object.values(checkedItems).filter(Boolean).length, target: props.questions ? props.questions.length : 5 }],
                }),
            },
            });
        } catch (error) {
            console.log(error);
        }
    };

    const questions = [
      "Did you try to keep eye contact?",
      "Did you listen to your friend?",
      "Did you pay attention to facial expressions?",
      "Did you have good posture?",
      "Did you stay at arm's length?",
    ]
  
    const toggleItem = (index) => {
      setCheckedItems(prev => ({ ...prev, [index]: !prev[index] }))
    }

    const finish = async () => {
        await updateScore();
        props.finish();
    }

    const atLeastOneChecked = Object.values(checkedItems).some(Boolean)
    
    // Check if all questions are answered (for props.questions mode)
    const allQuestionsAnswered = props.questions 
        ? props.questions.every((_, index) => checkedItems[index] !== undefined)
        : questions ? questions.every((_, index) => checkedItems[index] !== undefined) : true

    return (
        <div className='valuationBody'>
            <div className="container">
                <h1 className="title">{props.questions ? "Skills Scorecard" : "Foundational Skills"}</h1>
                {props.questions && <h2 className="subtitle">Your scores will be saved to track your growth. Answer all of the questions to continue.</h2>}
                <div className="question-list">
                    {(props.questions ? props.questions : questions).map((question, index) => (
                    <div key={index} className="question-item">
                        <div className="question-content">
                            {/* <img alt="volume icon" className="sound-button" src={Icon_volume} onClick={() => {}}/> */}
                            <span className="question-text">{question}</span>
                        </div>
                        {props.questions ? (
                            <div className="yes-no-options">
                                <span 
                                    className={`yes-no-option ${checkedItems[index] === true ? 'selected' : ''}`}
                                    onClick={() => setCheckedItems(prev => ({ ...prev, [index]: true }))}
                                >
                                    yes
                                </span>
                                <span 
                                    className={`yes-no-option ${checkedItems[index] === false ? 'selected' : ''}`}
                                    onClick={() => setCheckedItems(prev => ({ ...prev, [index]: false }))}
                                >
                                    no
                                </span>
                            </div>
                        ) : (
                            // <Checkbox
                            //     checked={checkedItems[index] || false}
                            //     onChange={() => toggleItem(index)}
                            //     className="checkbox"
                            //     size={"large"}
                            // />
                            <div className="yes-no-options">
                                <span 
                                    className={`yes-no-option ${checkedItems[index] === true ? 'selected' : ''}`}
                                    onClick={() => setCheckedItems(prev => ({ ...prev, [index]: true }))}
                                >
                                    yes
                                </span>
                                <span 
                                    className={`yes-no-option ${checkedItems[index] === false ? 'selected' : ''}`}
                                    onClick={() => setCheckedItems(prev => ({ ...prev, [index]: false }))}
                                >
                                    no
                                </span>
                            </div>
                        )}
                    </div>
                    ))}
                </div>
                {/* <ButtonWithSound 
                    button={true} 
                    className={`finish-button ${!allQuestionsAnswered ? 'disabled' : ''}`} 
                    onClick={allQuestionsAnswered ? finish : undefined} 
                    label={"FINISH"}
                    disabled={!allQuestionsAnswered}
                /> */}
            </div>
            <div className="footer">
                {allQuestionsAnswered && <h2 className="bounce-animation"><a onClick={finish}>FINISH &#62;</a></h2>}
            </div>
        </div>
    );
};
export default Valuation;
